var _excluded = ["user", "size", "onClick"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import PropTypes from "prop-types";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import { stringToColor } from "../../../constants";
function UserAvatar(props) {
  var size = props.size,
    user = props.user,
    className = props.className,
    onClick = props.onClick;
  var width, height, fontSize;
  if (size === "xs") {
    width = 25;
    height = 25;
    fontSize = 12;
  } else if (size === "sm") {
    width = 33;
    height = 33;
    fontSize = 18;
  } else if (size === "md") {
    width = 40;
    height = 40;
    fontSize = 20;
  } else if (size === "lg") {
    width = 80;
    height = 80;
    fontSize = 40;
  } else if (size === "xl") {
    width = 150;
    height = 150;
    fontSize = 64;
  } else {
    throw new Error("Size not supported.");
  }
  var forwardProps = function (_ref) {
    var user = _ref.user,
      size = _ref.size,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, _excluded);
    return rest;
  }(props);
  return /*#__PURE__*/React.createElement(Badge, {
    variant: "dot",
    overlap: "circular",
    color: "primary",
    invisible: !user || user.type !== "AiUser",
    badgeContent: " "
  }, user && user.profilePicture && /*#__PURE__*/React.createElement(Avatar, _extends({
    src: user.profilePicture.src,
    onError: function onError(e) {
      e.target.onerror = null;
      e.target.src = "/img/image_missing.png";
    },
    className: className,
    style: {
      width: width,
      height: height
    },
    onClick: onClick
  }, forwardProps)), user && !user.profilePicture && /*#__PURE__*/React.createElement("div", {
    className: "rounded-circle",
    style: {
      width: width,
      height: height
    }
  }, /*#__PURE__*/React.createElement(Avatar, _extends({
    className: className,
    style: {
      color: "#fff",
      backgroundColor: stringToColor(user.initials, 0.7),
      width: width,
      height: height,
      fontSize: fontSize
    },
    onClick: onClick
  }, forwardProps), user.initials)), !user && /*#__PURE__*/React.createElement(Avatar, _extends({
    onError: function onError(e) {
      e.target.onerror = null;
      e.target.src = "/img/image_missing.png";
    },
    className: className,
    style: {
      width: width,
      height: height
    },
    onClick: onClick
  }, forwardProps)));
}
export default UserAvatar;
UserAvatar.defaultProps = {
  size: "md"
};
UserAvatar.propTypes = {
  user: PropTypes.object,
  size: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
};